import { render, staticRenderFns } from "./SetMFA.vue?vue&type=template&id=3af9f71a&"
import script from "./SetMFA.vue?vue&type=script&lang=js&"
export * from "./SetMFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SetMFA.vue"
export default component.exports